export enum TxType {
  // NFCS
  NFCSMinted = 'NFCSMinted',

  // PoolInvestor
  BorrowSuccessful = 'BorrowSuccessful',
  InterestRateAnnualSet = 'InterestRateAnnualSet',
  LiquidityDeposited = 'LiquidityDeposited',
  LiquidityWithdrawn = 'LiquidityWithdrawn',
  ReserveRateSet = 'ReserveRateSet',
  StakingRewardClaimed = 'StakingRewardClaimed',

  // RevenueManager
  AcceptedCollateralAdded = 'AcceptedCollateralAdded',
  AcceptedCollateralRemoved = 'AcceptedCollateralRemoved',
  BalancingFundsRequested = 'BalancingFundsRequested',

  // RociPayment
  Liquidated = 'Liquidated',
  CollateralDeposited = 'CollateralDeposited',
  CollateralWithdrawn = 'CollateralWithdrawn',
  LoanRepaid = 'LoanRepaid',

  // ScoreDB
  ScoreUpdated = 'ScoreUpdated',

  // Unknown
  Unknown = 'Unknown',
}
